export const __VARS = {
  userSessionCookieName: process.env.NEXT_PUBLIC_COOKIE_NAME ?? "user-session",
  serverUrl: process.env.NEXT_PUBLIC_LK_SERVER_URL,
  signOutApiPage: `/api/auth/sign-out`,
  loginUrl: `/fa/sign-in`,
};
